import React from "react";

const NewZealand = () => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 20 15"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="15"
        id="mask0_305_22665"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="20"
        x="0"
        y="0"
      >
        <rect fill="white" height="15" width="20" />
      </mask>
      <g mask="url(#mask0_305_22665)">
        <path
          clipRule="evenodd"
          d="M0 0V15H20V0H0Z"
          fill="#2E42A5"
          fillRule="evenodd"
        />
        <mask
          height="15"
          id="mask1_305_22665"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          width="20"
          x="0"
          y="0"
        >
          <path
            clipRule="evenodd"
            d="M0 0V15H20V0H0Z"
            fill="white"
            fillRule="evenodd"
          />
        </mask>
        <g mask="url(#mask1_305_22665)">
          <rect fill="#2E42A5" height="9" width="11" />
          <mask
            height="9"
            id="mask2_305_22665"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "alpha" }}
            width="11"
            x="0"
            y="0"
          >
            <rect fill="white" height="9" width="11" />
          </mask>
          <g mask="url(#mask2_305_22665)">
            <path
              d="M-1.25266 8.12482L1.22294 9.21057L11.3062 1.1804L12.612 -0.43306L9.96471 -0.795949L5.852 2.66448L2.54169 4.996L-1.25266 8.12482Z"
              fill="#F7FCFF"
            />
            <path
              d="M-0.913757 8.88555L0.347444 9.51562L12.1431 -0.582947H10.3722L-0.913757 8.88555Z"
              fill="#F50100"
            />
            <path
              d="M12.5027 8.12493L10.3056 9.52063L-0.0561867 1.1805L-1.36201 -0.432954L1.28529 -0.795844L5.398 2.66459L8.70831 4.99611L12.5027 8.12493Z"
              fill="#F7FCFF"
            />
            <path
              d="M12.4182 8.67082L11.157 9.3009L6.13428 4.97718L4.64515 4.4941L-1.48766 -0.427482H0.283216L6.41258 4.37728L8.04068 4.95655L12.4182 8.67082Z"
              fill="#F50100"
            />
            <mask
              fill="black"
              height="11"
              id="path-11-outside-1_305_22665"
              maskUnits="userSpaceOnUse"
              width="13"
              x="-1"
              y="-1"
            >
              <rect fill="white" height="11" width="13" x="-1" y="-1" />
              <path
                clipRule="evenodd"
                d="M6 0H5V4H0V5H5V9H6V5H11V4H6V0Z"
                fillRule="evenodd"
              />
            </mask>
            <path
              clipRule="evenodd"
              d="M6 0H5V4H0V5H5V9H6V5H11V4H6V0Z"
              fill="#F50100"
              fillRule="evenodd"
            />
            <path
              d="M5 0V-0.9375H4.0625V0H5ZM6 0H6.9375V-0.9375H6V0ZM5 4V4.9375H5.9375V4H5ZM0 4V3.0625H-0.9375V4H0ZM0 5H-0.9375V5.9375H0V5ZM5 5H5.9375V4.0625H5V5ZM5 9H4.0625V9.9375H5V9ZM6 9V9.9375H6.9375V9H6ZM6 5V4.0625H5.0625V5H6ZM11 5V5.9375H11.9375V5H11ZM11 4H11.9375V3.0625H11V4ZM6 4H5.0625V4.9375H6V4ZM5 0.9375H6V-0.9375H5V0.9375ZM5.9375 4V0H4.0625V4H5.9375ZM0 4.9375H5V3.0625H0V4.9375ZM0.9375 5V4H-0.9375V5H0.9375ZM5 4.0625H0V5.9375H5V4.0625ZM5.9375 9V5H4.0625V9H5.9375ZM6 8.0625H5V9.9375H6V8.0625ZM5.0625 5V9H6.9375V5H5.0625ZM11 4.0625H6V5.9375H11V4.0625ZM10.0625 4V5H11.9375V4H10.0625ZM6 4.9375H11V3.0625H6V4.9375ZM5.0625 0V4H6.9375V0H5.0625Z"
              fill="#F7FCFF"
              mask="url(#path-11-outside-1_305_22665)"
            />
          </g>
          <path
            clipRule="evenodd"
            d="M15.5332 12.8125L14.4311 13.3919L14.6416 12.1647L13.75 11.2956L14.9822 11.1165L15.5332 10L16.0843 11.1165L17.3165 11.2956L16.4248 12.1647L16.6353 13.3919L15.5332 12.8125Z"
            fill="#F50100"
            fillRule="evenodd"
            stroke="#F7FCFF"
            strokeWidth="0.5"
          />
          <path
            clipRule="evenodd"
            d="M13.25 8.66864L12.4002 9.11541L12.5625 8.16914L11.875 7.499L12.8251 7.36094L13.25 6.5L13.6749 7.36094L14.625 7.499L13.9375 8.16914L14.0998 9.11541L13.25 8.66864Z"
            fill="#F50100"
            fillRule="evenodd"
            stroke="#F7FCFF"
            strokeWidth="0.5"
          />
          <path
            clipRule="evenodd"
            d="M17.6235 8.66623L16.7746 9.1125L16.9367 8.16729L16.25 7.49789L17.199 7.35998L17.6235 6.5L18.0479 7.35998L18.9969 7.49789L18.3102 8.16729L18.4723 9.1125L17.6235 8.66623Z"
            fill="#F50100"
            fillRule="evenodd"
            stroke="#F7FCFF"
            strokeWidth="0.5"
          />
          <path
            clipRule="evenodd"
            d="M15.75 5.16864L14.9002 5.61541L15.0625 4.66914L14.375 3.999L15.3251 3.86094L15.75 3L16.1749 3.86094L17.125 3.999L16.4375 4.66914L16.5998 5.61541L15.75 5.16864Z"
            fill="#F50100"
            fillRule="evenodd"
            stroke="#F7FCFF"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </svg>
  );
};

export default NewZealand;
